import product1 from "./Assets/Products/1.png";
import product2 from "./Assets/Products/2.png";
import product3 from "./Assets/Products/3.png";
import product4 from "./Assets/Products/4.png";
import product5 from "./Assets/Products/5.png";
import product6 from "./Assets/Products/6.jpeg"
import product7 from "./Assets/Products/7.jpg";
import product8 from "./Assets/Products/8.jpeg";
export const PRODUCTS = [
  {
    id: 1,
    name: "Iphone",
    price: 999.0,
    productImage: product1,
  },
  {
    id: 2,
    name: "M1 Mackbook Pro",
    price: 1020.0,
    productImage: product2,
  },
  {
    id: 3,
    name: "Cannon m50 Camera",
    price: 1000.0,
    productImage: product3,
  },
  {
    id: 4,
    name: "Denim jacket",
    price: 200.0,
    productImage: product4,
  },
  {
    id: 5,
    name: "LED Light Strips",
    price: 19.0,
    productImage: product5,
  },
  {
    id: 6,
    name: "Spectrum LS",
    price: 68.0,
    productImage: product6,
  },
  {
    id: 7,
    name: "Shirt",
    price: 120.0,
    productImage: product8,
  },
  {
    id: 8,
    name: "Hat",
    price: 40.0,
    productImage: product7,
  },
];
